import { Component, OnInit } from '@angular/core';
import { BlogService } from '../services/blog.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { Subject, Observable } from 'rxjs';
import { SkillService } from '../../skill-matrix/services/skill.service';
import { ByEmployee } from '../../skill-matrix/api-interfaces';
import { FlashService } from '../../flash/flash.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-edit-blog',
  templateUrl: './edit-blog.component.html',
  styleUrls: ['./edit-blog.component.css']
})
export class EditBlogComponent implements OnInit {
  blogForm: FormGroup;
  employeeDetail: Observable<ByEmployee>
  private destroy: Subject<void> = new Subject<void>();
  private urlValidate: RegExp = new RegExp(/(https)?:\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/);
  id;
  private sub: any;
  editData;

  constructor(
    public blogService: BlogService,
    private formBuilder: FormBuilder,
    private location: Location,
    public skillService: SkillService,
    public flashService: FlashService,
    private router: Router,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
  ) {
    this.employeeDetail = this.skillService.getEmployee();
    this.blogForm = this.formBuilder.group({
      title: new FormControl('', Validators.required),
      url: new FormControl('', [Validators.pattern(this.urlValidate)]),
      emp_id: new FormControl('', Validators.required),
      submission_date: new FormControl('', Validators.required),
      published_date: new FormControl('', Validators.required),
    });
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];
    });

    this.editData = this.blogService.editData;
    const pubDate = new Date(this.editData.published_date)
    const subDate = new Date(this.editData.submission_date)
    this.blogForm.patchValue({
      'title': this.editData.title,
      'url': this.editData.url,
      'emp_id': this.editData.emp_id,
      'submission_date': this.stringToDate(subDate),
      'published_date': this.stringToDate(pubDate)
    });
  }

  locationBack() {
    this.location.back();
  }

  stringToDate(value) {
    const dateObject = {
      date: {
        year: value.getFullYear(),
        month: (value.getMonth() + 1), day: (value.getDate())
      }
    };
    return dateObject;
  }
  dateToString(value) {
    const dateString = value.date.year + '-' +
      (value.date.month < 9 ? '0' : '') + value.date.month + '-' +
      (value.date.day < 10 ? '0' : '') + value.date.day;
    return dateString;
  }
  onSubmit(formData) {
    this.spinnerService.show();
    if (formData.valid) {
      this.spinnerService.hide();
      formData.value.submission_date = this.dateToString(formData.value.submission_date);
      formData.value.published_date = this.dateToString(formData.value.published_date);
      this.blogService.editBlog(formData.value, this.id).takeUntil(this.destroy).subscribe()
      this.router.navigateByUrl('blogList');
      this.flashService.show('Blog updated successfully', 'alert-success')
    }
    else {
      this.spinnerService.hide();
      this.flashService.show('Update the blog', 'alert-danger')
    }
  }
  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/blog/edit-blog/edit-blog.component.ts